import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M38.208 556.288c19.072 0 32 16.64 32 35.712v7.872c0 .32 3.072.512 3.072.832 32.128 185.28 219.52 326.272 414.08 326.272 194.432 0 379.008-140.864 411.136-326.208a11.52 11.52 0 0111.328-9.664h46.848c7.04 0 11.2 6.272 10.112 13.312-34.176 222.08-250.56 392.192-482.304 392.192-162.752 0-321.6-84.032-414.272-210.88v86.4c0 19.072-14.336 31.744-33.408 31.744l.64-.064-4.928-.256c-15.04-1.984-28.48-11.712-31.296-25.92l-.512-5.504V592c0-19.072 17.024-35.712 36.096-35.712zm-.768 347.52l.768.064H36.8l.64-.064zm359.488-424.64a5.952 5.952 0 019.28 5.056v83.648h289.6a34.816 34.816 0 010 69.632h-289.6v66.304c0 4.8-5.312 7.68-9.28 4.992l-127.04-109.824a5.952 5.952 0 010-9.984zM598.4 269.632l2.56.96 126.912 109.824a6.016 6.016 0 01-.064 9.984l-127.04 109.824a5.952 5.952 0 01-9.28-5.056V417.28h-289.6a34.816 34.816 0 010-69.568h289.728v-72.128c0-4.8 5.312-7.68 9.28-4.992zM489.6.32c163.328 0 321.984 84.48 414.72 212.096v-93.824c0-19.2 14.464-37.184 33.6-37.184h-.64l5.12.512c14.976 2.752 28.16 15.936 30.976 30.912l.512 5.696v280.064c0 19.136-17.984 30.336-37.12 30.336H934.4c-18.88 0-34.304-13.056-34.688-31.808-.64-1.024-1.024.192-1.216-1.024-32.128-185.28-216.704-326.272-411.2-326.272-194.496 0-379.2 140.992-411.2 326.144a11.52 11.52 0 01-11.328 9.728H17.92c-7.104 0-11.52-6.272-10.432-13.312C41.792 170.368 257.984.32 489.6.32zm448.32 81.088h-1.28 1.28z"
});

function SvgTransferCircle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "transferCircle_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferCircle);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'TransferCircleOutlined';

export default KuFoxIcons;
